import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import CartComponent from "../CartComponent";
import TextComponent from "../TextComponent";
import ProductsComponent from "../Products/ProductsComponent";
import FooterComponent from "../FooterComponent";
import ButtonComponent from "../ButtonComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import Checkout from "../Checkout/Checkout";
import ProductDetailComponent from "../ProductDetail/ProductDetailComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  cart: CartComponent,
  text: TextComponent,
  ProductsComponent: ProductsComponent,
  footer: FooterComponent,
  Button: ButtonComponent,
  inner_section: InnerSectionComponent,
  Checkout: Checkout,
  ProductDetailComponent: ProductDetailComponent,
};
